export default {
  buttons: {
    create: 'Utwórz',
    update: 'Zaktualizuj',
    cancel: 'Anuluj',
  },
  fields: {
    title: {
      label: 'Tytuł',
      placeholder: 'Wprowadź tytuł',
    },
    description: {
      label: 'Opis',
      placeholder: 'Wprowadź opis',
    },
    button_text: {
      label: 'Tekst przycisku',
      placeholder: 'Wprowadź tekst przycisku',
    },
    button_url: {
      label: 'URL przycisku',
      placeholder: 'https://example.com',
    },
    image: {
      label: 'Obraz',
    },
  },
  title: 'Utwórz post',
};
